import { render, staticRenderFns } from "./modal-edit.vue?vue&type=template&id=2ac6e95b&"
import script from "./modal-edit.vue?vue&type=script&lang=js&"
export * from "./modal-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports